import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 5px 10px;
  display: flex;
  align-items: center; 
  font-size: 16px;
  font-weight: 500;
  color: #111;
  max-width: 50%;
`;

export const StepBadge = styled.span`
  background-color: #1e4e9c; 
  color: white;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: bold;
  margin-right: 8px;
  flex-shrink: 0;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
`;